/**
 * Registrar Api
 * The registrar api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Condition { 
    source: string;
    operator: Condition.OperatorEnum;
    value: object;
    path: string;
}
export namespace Condition {
    export type OperatorEnum = 'equals' | 'not equals' | 'contains' | 'starts with' | 'ends with';
    export const OperatorEnum = {
        Equals: 'equals' as OperatorEnum,
        NotEquals: 'not equals' as OperatorEnum,
        Contains: 'contains' as OperatorEnum,
        StartsWith: 'starts with' as OperatorEnum,
        EndsWith: 'ends with' as OperatorEnum
    };
}


